"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import { Historyitem } from "./Historyitem";
import * as _utils from "./utils";
import _styles from "./History.module.css";
import moment from "moment";
import { Loader } from "../component/common/Loader";
import { customCalendar } from "../common/const";

const _interactionsData = JSON.parse(
  '{"events":{"e-877":{"id":"e-877","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-8","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-878"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"d105f99f-87d8-00b1-ab20-2f34de1ff959","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"d105f99f-87d8-00b1-ab20-2f34de1ff959","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721147750720},"e-969":{"id":"e-969","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-59","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-970"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8f56a87f-1e4c-608f-7a46-b44695f74007","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8f56a87f-1e4c-608f-7a46-b44695f74007","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721223210325},"e-971":{"id":"e-971","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-60","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-972"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"82b60712-1db2-82f6-9779-f7d827476abe","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"82b60712-1db2-82f6-9779-f7d827476abe","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721223253184},"e-973":{"id":"e-973","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-24","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-974"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"45b02e6c-bce3-12cd-d211-bb23dd0617a9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"45b02e6c-bce3-12cd-d211-bb23dd0617a9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721223930556},"e-974":{"id":"e-974","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-25","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-973"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"45b02e6c-bce3-12cd-d211-bb23dd0617a9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"45b02e6c-bce3-12cd-d211-bb23dd0617a9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721223930559},"e-975":{"id":"e-975","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-24","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-976"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"f7ba739e-fcfd-6b2c-975f-681913601607","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"f7ba739e-fcfd-6b2c-975f-681913601607","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721223975769},"e-976":{"id":"e-976","name":"","animationType":"preset","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-25","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-975"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"f7ba739e-fcfd-6b2c-975f-681913601607","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"f7ba739e-fcfd-6b2c-975f-681913601607","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721223975769}},"actionLists":{"a-8":{"id":"a-8","title":"dialer/contacts to oncall","actionItemGroups":[{"actionItems":[{"id":"a-8-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"PARENT","selector":".phone_dialer","selectorGuids":["4c1e0262-5998-4bad-61c6-e320c7a90f01"]},"value":"none"}},{"id":"a-8-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{},"value":"none"}},{"id":"a-8-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{},"value":"flex"}},{"id":"a-8-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".history","selectorGuids":["69e20447-9e8a-4c7a-b9bf-d8787134d1b8"]},"value":"none"}},{"id":"a-8-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".phone_oncall","selectorGuids":["9c08117b-d5fb-d78c-1ca7-a4bbfbda9359"]},"value":"flex"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1701700810673},"a-59":{"id":"a-59","title":"return to history","actionItemGroups":[{"actionItems":[{"id":"a-59-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"PARENT","selector":".leadconversation-main","selectorGuids":["90bbc54c-84e7-6f65-1011-735715452387"]},"value":"none"}},{"id":"a-59-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".history","selectorGuids":["69e20447-9e8a-4c7a-b9bf-d8787134d1b8"]},"value":"flex"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1721223218070},"a-60":{"id":"a-60","title":"leadconversation [go]","actionItemGroups":[{"actionItems":[{"id":"a-60-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".leadconversation-main","selectorGuids":["90bbc54c-84e7-6f65-1011-735715452387"]},"value":"flex"}},{"id":"a-60-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"PARENT","selector":".history","selectorGuids":["69e20447-9e8a-4c7a-b9bf-d8787134d1b8"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1721223255293},"a-24":{"id":"a-24","title":"filter popup [show]","actionItemGroups":[{"actionItems":[{"id":"a-24-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".filter-popup","selectorGuids":["e8ec8c55-aa11-a1fe-c754-f51baf989d52"]},"value":"flex"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1701792305692},"a-25":{"id":"a-25","title":"filter popup [hide]","actionItemGroups":[{"actionItems":[{"id":"a-25-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".filter-popup","selectorGuids":["e8ec8c55-aa11-a1fe-c754-f51baf989d52"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1701792332125}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function History({ as: _Component = _Builtin.Block, history = [], historyLoading = false, handleHistoryClick = () => { },
  interDataLeadsExist = false
}) {
  _interactions.useInteractions(_interactionsData, _styles);
  return (
    <_Component className={_utils.cx(_styles, "history")} tag="div" style={{ display: interDataLeadsExist ? "none" : "flex" }}>
      <_Builtin.Block className={_utils.cx(_styles, "phonetop")} tag="div">
        <_Builtin.Block
          className={_utils.cx(_styles, "phonetop_left")}
          tag="div"
        >
          <_Builtin.Heading
            className={_utils.cx(_styles, "phoneheader_text")}
            tag="h3"
          >
            {"History"}
          </_Builtin.Heading>
        </_Builtin.Block>
        <_Builtin.Block
          className={_utils.cx(_styles, "socialstop_right")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "phonetop_iconbtn", "mr-5")}
            data-w-id="45b02e6c-bce3-12cd-d211-bb23dd0617a9"
            tag="div"
          >
            <_Builtin.Image
              className={_utils.cx(_styles, "image-100")}
              width="auto"
              height="auto"
              loading="lazy"
              alt=""
              src="images/66969177ee1a6a8cbeae5e12_inbox_02.svg"
            />
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "filter-popup")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "filter-item")}
              tag="div"
            >
              <_Builtin.FormCheckboxWrapper
                className={_utils.cx(
                  _styles,
                  "checkbox-field",
                  "flex-horixontal"
                )}
              >
                <_Builtin.FormCheckboxInput
                  className={_utils.cx(_styles, "checkbox")}
                  type="checkbox"
                  name="checkbox-4"
                  data-name="Checkbox 4"
                  required={false}
                  checked={false}
                  id="checkbox-4"
                  form={{
                    type: "checkbox-input",
                    name: "Checkbox 4",
                  }}
                  inputType="default"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "checkbox_textcontent")}
                  tag="div"
                >
                  <_Builtin.Block tag="div">{"All Activity"}</_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.FormInlineLabel
                  className={_utils.cx(_styles, "checkbox-label")}
                >
                  {"Checkbox 4"}
                </_Builtin.FormInlineLabel>
              </_Builtin.FormCheckboxWrapper>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "filter-item")}
              tag="div"
            >
              <_Builtin.FormCheckboxWrapper
                className={_utils.cx(
                  _styles,
                  "checkbox-field",
                  "flex-horixontal"
                )}
              >
                <_Builtin.FormCheckboxInput
                  className={_utils.cx(_styles, "checkbox")}
                  type="checkbox"
                  name="checkbox-4"
                  data-name="Checkbox 4"
                  required={false}
                  checked={false}
                  id="checkbox-4"
                  form={{
                    type: "checkbox-input",
                    name: "Checkbox 4",
                  }}
                  inputType="default"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "checkbox_textcontent")}
                  tag="div"
                >
                  <_Builtin.Block tag="div">{"Call"}</_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.FormInlineLabel
                  className={_utils.cx(_styles, "checkbox-label")}
                >
                  {"Checkbox 4"}
                </_Builtin.FormInlineLabel>
              </_Builtin.FormCheckboxWrapper>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "filter-item")}
              tag="div"
            >
              <_Builtin.FormCheckboxWrapper
                className={_utils.cx(
                  _styles,
                  "checkbox-field",
                  "flex-horixontal"
                )}
              >
                <_Builtin.FormCheckboxInput
                  className={_utils.cx(_styles, "checkbox")}
                  type="checkbox"
                  name="checkbox-4"
                  data-name="Checkbox 4"
                  required={false}
                  checked={false}
                  id="checkbox-4"
                  form={{
                    type: "checkbox-input",
                    name: "Checkbox 4",
                  }}
                  inputType="default"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "checkbox_textcontent")}
                  tag="div"
                >
                  <_Builtin.Block tag="div">{"SMS"}</_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.FormInlineLabel
                  className={_utils.cx(_styles, "checkbox-label")}
                >
                  {"Checkbox 4"}
                </_Builtin.FormInlineLabel>
              </_Builtin.FormCheckboxWrapper>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "filter-item")}
              tag="div"
            >
              <_Builtin.FormCheckboxWrapper
                className={_utils.cx(
                  _styles,
                  "checkbox-field",
                  "flex-horixontal"
                )}
              >
                <_Builtin.FormCheckboxInput
                  className={_utils.cx(_styles, "checkbox")}
                  type="checkbox"
                  name="checkbox-4"
                  data-name="Checkbox 4"
                  required={false}
                  checked={false}
                  id="checkbox-4"
                  form={{
                    type: "checkbox-input",
                    name: "Checkbox 4",
                  }}
                  inputType="default"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "checkbox_textcontent")}
                  tag="div"
                >
                  <_Builtin.Block tag="div">{"Email"}</_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.FormInlineLabel
                  className={_utils.cx(_styles, "checkbox-label")}
                >
                  {"Checkbox 4"}
                </_Builtin.FormInlineLabel>
              </_Builtin.FormCheckboxWrapper>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
      {historyLoading ? <Loader /> : <_Builtin.Block className={_utils.cx(_styles, "cardbody_div")} tag="div">
        {history.length !== 0 ? history.map((item, index) => (
          <Historyitem key={index}
            date={moment(item.history[item.history?.type]?.timestamp).calendar(null, customCalendar)}
            time={moment(item.history[item.history?.type]?.timestamp).format('HH:mm')}
            activityType={item.history[item.history?.type]?.direction === "inbound" ? "Inbound Call" : "Outbound Call"}
            activityDescription={item.history[item.history?.type]?.direction === "inbound" ? "Phone Call from" : "Phone Call to"}
            activityUser={item.history[item.history?.type]?.interactionWith}
            historyData={item.history[item.history?.type]}
            handleHistoryClick={handleHistoryClick}
          />
        )): "No history found"}
      </_Builtin.Block>}

    </_Component>
  );
}
